import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 外部ETサイト - 解約チャットアプリ連携一覧取得
export async function getOutsideEntrySiteCancellChatApps(id: string) {
  try {
    const path = "outsideEntrySiteCancellChatApps";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 外部ETサイト - 解約チャットアプリ連携詳細取得
export async function getOutsideEntrySiteCancellChatApp(id: string) {
  try {
    const path = "outsideEntrySiteCancellChatApp";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.detail_data && response.data.detail_data.length > 0) {
      return response.data.detail_data[0];
    }
    return null;
  } catch (error) {
    return null;
  }
}
// 外部ETサイト - 解約チャットアプリ連携詳細編集
export async function putOutsideEntrySiteCancellChatApp(
  editData: EditDataDifine
) {
  try {
    const path = "outsideEntrySiteCancellChatApp";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 外部ETサイト - 解約チャットアプリ連携登録
export async function postOutsideEntrySiteCancellChatApp(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntrySiteCancellChatApp";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 外部ETサイト - 解約チャットアプリ連携削除
export async function deleteOutsideEntrySiteCancellChatApp(id: string) {
  try {
    const path = "outsideEntrySiteCancellChatApp";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
